import React from 'react';
import { connect } from 'react-redux';
import EditCategoryForm from './TrackingCategoriesEditCustomForm';
import { Edit, showNotification, withDataProvider } from 'react-admin';
import LoadingIndicator from '../../components/LoadingIndicator';
import ConfirmationModal from '../../components/ConfirmationModal';
import { handleAPIErrors } from '../../utils';

export const isTrackingCategoryResourceLoaded = (state) => {
  return state['visibleName'] !== '' && state['label'] !== '';
};

export const constructCategoryDescriptionsPayload = (categoryDescriptionToMap, state) => {
  let categoryDescriptionsResult = state.descriptions.slice();

  return categoryDescriptionsResult.map((description) => {
    if (categoryDescriptionToMap.id === description.id) {
      return categoryDescriptionToMap;
    } else {
      return description;
    }
  });
};

export const buildCategoryUpdatePayload = (formValues, state) => {
  let requestPayload = {};

  requestPayload.website = state.website;
  requestPayload.parentCategory = state.parentCategory;
  requestPayload.label = state.label;
  requestPayload.descriptions = constructCategoryDescriptionsPayload(formValues.categoryDescription, state);

  return requestPayload;
};

class TrackingCategoriesEdit extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      visibleName: '',
      label: '',
      website: '',
      categoryDescription: {},
      languages: [],
      chosenLanguage: {},
      descriptions: [],
      showDialog: false,
    };
    ({dataProvider: this.dataProvider} = this.props);
  }

  componentDidMount() {
    this.loadTrackingCategoryResource();
  }

  async loadTrackingCategoryResource() {
    this.dataProvider.getOne('tracking_categories', {id: this.props.id})
      .then(trackingCategory => {
        this.setState({...trackingCategory.data});

        return this.dataProvider.getMany('tracking_category_descriptions', {ids: trackingCategory.data.descriptions});
      })
      .then(categoriesDescriptions => {
        let categoryDescription = categoriesDescriptions.data[0] || {};

        this.setState({descriptions: categoriesDescriptions.data, categoryDescription: categoryDescription});

        let languagesIds = this.state.descriptions.map(description => description.language);

        return this.dataProvider.getMany('languages', {ids: languagesIds});
      })
      .then(languages => {
        const chosenLanguage = languages.data.find(lang => lang.id === this.state.categoryDescription.language);

        this.setState({languages: languages.data, chosenLanguage: chosenLanguage});
      })
      .catch(error => {
        handleAPIErrors(error, this.props.history);
        console.error(error);
      });
  };

  chooseLanguage(language) {
    let categoryDescription = this.state.descriptions.find(el => el.language === language.id);

    if (categoryDescription) {
      this.setState({categoryDescription: categoryDescription});
    }

    this.setState({chosenLanguage: language});
  }

  handleSubmit(formData) {
    this.setState({formData, showDialog: true});
  }

  async saveCategory() {
    const {formData} = this.state;
    const payload = buildCategoryUpdatePayload(formData, this.state);

    this.dataProvider.update('tracking_categories', {
      id: this.state.id,
      data: payload,
    })
      .then((response) => {
        this.props.showNotification('Consent category updated successfully !');
      })
      .catch(error => {
        handleAPIErrors(error, this.props.history);
      })
      .finally(() => {
        this.loadTrackingCategoryResource();
        this.closeDialogPrompt();
      });
  }

  closeDialogPrompt() {
    this.setState({
      showDialog: false,
    });
  }

  render() {
    const initialValues = {
      visibleName: this.state.visibleName,
      label: this.state.label,
      categoryDescription: this.state.categoryDescription,
    };

    const stepProps = {
      onLanguageChange: language => this.chooseLanguage(language),
      languages: this.state.languages,
      chosenLanguage: (this.state.chosenLanguage || {}).id,
      history: this.props.history,
    };

    const {dataProvider, ...rest} = this.props;

    return (<div>
        {
          isTrackingCategoryResourceLoaded(this.state) ?
            <Edit {...rest} toolbar={null} actions={null}>
              <EditCategoryForm initialValues={initialValues} onSubmit={(data) => this.handleSubmit(data)}
                                toolbar={null} enableReinitialize="true" {...stepProps} />
            </Edit> : <LoadingIndicator/>
        }
        <ConfirmationModal
          open={this.state.showDialog}
          title="Are you sure you want to save and publish changes?"
          message="The changes will be visible after 10 minutes and will overwrite this category in all templates on your website."
          okText="SAVE"
          cancelText="CANCEL"
          onOk={() => this.saveCategory()}
          onCancel={() => this.closeDialogPrompt()}
        />
      </div>
    );
  }
}

export default connect(null, {
  showNotification,
})(withDataProvider(TrackingCategoriesEdit));
